module.exports = __webpack_public_path__ + "sbcr_modal_logo.svg?08025a065eaa52364a077389c16c8011";